export default __webpack_public_path__ + "static/media/alice.9a767b85.png";